"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectToNativeAppPage = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const query_string_1 = __importDefault(require("query-string"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const app_store_download_svg_1 = __importDefault(require("../images/app-store-download.svg"));
const play_store_download_png_1 = __importDefault(require("../images/play-store-download.png"));
const useWindowResize_1 = __importDefault(require("../useWindowResize"));
const makeMyStyles = () => ({
    root: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: lib_palette_1.default.White.main,
    },
    logo: {
        display: 'block',
        margin: '30px auto',
        height: 40,
    },
    playStoreLogo: { display: 'block', margin: '30px auto', height: 55 },
});
let isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
        return isMobile.Android() || isMobile.iOS();
    },
};
function RedirectToNativeAppPage(props) {
    const { location } = props;
    const { nativeLink } = query_string_1.default.parse(location.search);
    const { logoBlack, hero } = (0, useAppState_1.default)();
    const hideGraphic = (0, useWindowResize_1.default)().width <= 760;
    const myCss = (0, web_css_1.default)(makeMyStyles);
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(react_router_dom_1.Route, { path: '*/nativeapp', component: () => {
                window.location.href = 'opsbase://' + nativeLink;
                return null;
            } }),
        react_1.default.createElement(Horizontal_1.default, { gutter: true, style: { height: '100%' } },
            !hideGraphic && (react_1.default.createElement("div", { style: {
                    width: '50%',
                    height: '100%',
                    display: 'flex',
                    backgroundColor: lib_palette_1.default.BackgroundGrey.main,
                } },
                react_1.default.createElement("img", { style: {
                        alignSelf: 'center',
                        width: '80%',
                        aspectRatio: '1',
                        margin: 'auto',
                    }, src: hero, alt: lib_i18n_1.default.t('opsbase') }))),
            react_1.default.createElement(Pane_1.default, { grow: true, style: { display: 'flex', overflow: 'auto' } },
                react_1.default.createElement("div", { style: {
                        margin: 'auto',
                        paddingLeft: 5,
                        paddingRight: 5,
                    } },
                    react_1.default.createElement("img", { alt: "", className: myCss.logo, src: logoBlack, width: 250 }),
                    !isMobile.any() ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Text_1.default, { variant: 'h2' }, "To access, please open this link in a mobile browser."))) : isMobile.iOS() ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Text_1.default, { style: { padding: 10 } }, "Please download the app for your mobile from here."),
                        react_1.default.createElement("a", { href: "https://apps.apple.com/gb/app/opsbase/id1458068032", target: "_blank" },
                            react_1.default.createElement("img", { alt: "", className: myCss.logo, src: app_store_download_svg_1.default })))) : isMobile.Android ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Text_1.default, { style: { padding: 10 } },
                            ' ',
                            "Please download the app for your mobile from here.",
                            ' '),
                        react_1.default.createElement("a", { href: "https://play.google.com/store/apps/details?id=com.opsboard", target: "_blank" },
                            react_1.default.createElement("img", { alt: "", className: myCss.playStoreLogo, src: play_store_download_png_1.default })))) : (''))))));
}
exports.RedirectToNativeAppPage = RedirectToNativeAppPage;
exports.default = RedirectToNativeAppPage;
